<template>
  <div>
    <div
      v-if="isConnected"
      class="button is-success is-small"
    >
      <span>
        <i class="fa fa-check" />
      </span>
      &nbsp;
      <span>
        Connected to Zoom
      </span>
    </div>

    <div
      v-else-if="connectionInProgress"
      class="button is-info is-small"
    >
      <i class="fa fa-spinner fa-spin" />
      Connecting to Zoom
    </div>

    <div
      v-else-if="isConnected === undefined"
      class="button is-light is-small"
    >
      <i class="fa fa-spinner fa-spin" />
      Checking Zoom Connection
    </div>

    <!--
    <a
      v-else
      :href="authURL.href"
      class="button-base tw-bg-sky-600 hover:tw-bg-sky-700 tw-text-gray-200 hover:tw-text-white"
    >
      <i class="fa fa-plug" />
      Connect to Zoom
    </a>
    -->

    <router-link
      v-else
      to="/advisor/integrations"
      class="button-base tw-bg-sky-600 hover:tw-bg-sky-700 tw-text-gray-200 hover:tw-text-white"
    >
      <i class="fa fa-plug" />
      Connect to Zoom
    </router-link>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ZoomConnect',
  components: { /* Subcomponents */ },
  props: {
    isConnected: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      redirectBase: 'http://localhost:8000/ui/advisor/upcoming-meetings',
      clientID: null,
      prospectId: this.$route.params.prospectId,
      code: null,
      connectionInProgress: null,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    headers() {
      return {
        'X-CSRFToken': this.$root.$data.csrfToken,
        'Content-Type': 'application/json',
      };
    },
    redirectURL() {
      if (!this.prospectId) return this.redirectBase;
      return `${this.redirectBase}/${this.prospectId}`;
    },
    authURL() {
      const url = new URL('https://zoom.us/oauth/authorize');

      const params = {
        response_type: 'code',
        client_id: this.clientID,
        redirect_uri: this.redirectURL,
      };
      url.search = new URLSearchParams(params).toString();
      return url;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {
    // Managed in OAuthConnect.vue instead
    // this.getClientID();
    // this.getCode();
    // if (this.code) this.connect();
  },
  mounted() {},
  updated() {},
  methods: {
    async getClientID() {
      const res = await fetch('/api/v1/zoom/client', {
        method: 'GET',
        headers: this.headers,
      });
      const data = await res.json();
      this.clientID = data.client_id;
    },
    getCode() {
      this.code = this.$route.query.code;
      if (this.code) this.$router.replace({ query: {} });
    },
    async connect() {
      this.connectionInProgress = true;
      const res = await fetch('/api/v1/zoom/connect', {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify({ code: this.code, prospect_id: this.prospectId }),
      });
      const data = await res.json();
      console.log(data);
      this.$emit('connected');

      this.connectionInProgress = false;
    },
  },
};
</script>


<style scoped>
  .button-base {
    @apply tw-px-4 tw-py-2 tw-rounded-md tw-border-none;
    @apply tw-flex tw-gap-2 tw-items-center tw-justify-center;
  }
</style>
